import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { API_URL } from '../../utils/api';
import GroupManager from '../GroupManager';

const Groups = () => {
    const { getAuthHeaders, isReadOnly } = useAuth();
    const [groups, setGroups] = useState([]);

    const fetchGroups = async () => {
        try {
            const response = await fetch(`${API_URL}/groups`, {
                headers: getAuthHeaders()
            });

            if (response.ok) {
                const data = await response.json();
                setGroups(data);
            } else {
                console.error('Failed to fetch groups');
                setGroups([]);
            }
        } catch (error) {
            console.error('Error fetching groups:', error);
            setGroups([]);
        }
    };

    useEffect(() => {
        fetchGroups();
    }, []);

    return (
        <GroupManager
            groups={groups}
            fetchGroups={fetchGroups}
            API_URL={API_URL}
            getAuthHeaders={getAuthHeaders}
            isReadOnly={isReadOnly}
        />
    );
};

export default Groups;
